import Modal from "modal/Modal";
import FormValidator from "base/FormValidator";
import Message from "base/Message";
import Ajax from "base/Ajax";
import AlertModal from "modal/AlertModal";

class LoginModal extends Modal {

    constructor(settings = {}) {
        super($.extend(true, {class: "admin-modal--small"}, settings));
    }

    buildElement() {
        if (this.built) return;
        super.buildElement();

        let $form = eotwJSXFactory('form', {class: "admin-form"}, [
            eotwJSXFactory('h1', null, ["Session has expired"]),
            eotwJSXFactory('p', null, ["Your session has expired, you have been logged out. You can log back in below"]),
            eotwJSXFactory('div', {class: "admin-form__row"}, [
                eotwJSXFactory('label', {class: "admin-form__label", for: "admin-login-modal-email"}, ["Email"]),
                eotwJSXFactory('input', {class: "admin-form__input js-email", id: "admin-login-modal-email", 'data-type': "email", name: "email", value: window.User ? window.User.email : ""}),
                eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
            ]),
            eotwJSXFactory('div', {class: "admin-form__row"}, [
                eotwJSXFactory('label', {class: "admin-form__label", for: "admin-login-modal-password"}, ["Password"]),
                eotwJSXFactory('input', {type: "password", class: "admin-form__input js-password", id: "admin-login-modal-password", name: "password"}),
                eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
            ]),

            eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal", type: "submit"}, ["Login"]),
                eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel"}, ["Cancel"])
            ])
        ]);

        FormValidator.attach($form, {inputOptions: {messages: {empty: "You must enter your {name}"}}}).on("submit", ($form) => {
            let $btn = $form.find("button[type='submit']");
            if ($btn.is(".admin-btn--loading")) return;
            $btn.addClass("admin-btn--loading");

            Ajax.post("adminUsers", "login", {
                email: $form.find(".js-email").val(),
                password: $form.find(".js-password").val(),
            }, Ajax.ADMIN).then(() => {
                if (!window.User) {
                    window.location.reload();
                } else {
                    Ajax.get("adminUsers", "current").then((data) => {
                        if (data.id !== window.User.id) {
                            AlertModal.alert('Your user has changed, the page will now reload', 'Session has changed').on("hide destroy", () => {
                                window.location.reload();
                                return false;
                            });
                        } else {
                            window.User = data;
                            this.emit("logged-in");
                            this.hide();
                        }
                    }, () => {
                        window.location.reload();
                    });
                }
            }, (e) => {
                new Message(e.message, "Couldn't log you in");
                $btn.removeClass("admin-btn--loading");
            })
        });

        this.setContent($form);

        this.on("click", ".js-cancel", () => {
            this.emit("cancel");
            this.hide();
            return false;
        })
    }
}


export default LoginModal;
